import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getDisplayName } from '../utils/displayName';

const ImpersonationBanner: React.FC = () => {
  const navigate = useNavigate();
  const { isImpersonating, stopImpersonation, user } = useAuth();

  if (!isImpersonating) return null;

  const displayName = getDisplayName(user);

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-12 flex items-center justify-between">
        <div className="text-sm font-semibold">
          Impersonation mode: viewing as {displayName}
        </div>
        <button
          onClick={async () => {
            await stopImpersonation();
            navigate('/admin/dashboard');
          }}
          className="bg-white text-amber-600 px-3 py-1.5 rounded-full text-xs font-semibold hover:bg-amber-50 focus:outline-none focus:ring-2 focus:ring-white/70 focus:ring-offset-2 focus:ring-offset-amber-500"
          aria-label="Return to admin"
        >
          Return to Admin
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
